import { Injectable } from '@angular/core';
import { FieldLength } from '../general/field-length';

@Injectable({
  providedIn: 'root'
})

//A service to hold the shared methods to restrict key press for each method call for validation
export class KeyValidationService {
  fieldLength=FieldLength;
  constructor() { }

  validateNameCharacters(event){  
    var regex = new RegExp(this.fieldLength.NamePattern);
    return this.matchRegex(regex,event.key);
  }

  matchRegex(regex : RegExp,key :any){
    if (!regex.test(key)) {
      key.preventDefault();
      return false;
    }
  }

  validateUENCharacters(event){
    var regex = new RegExp(this.fieldLength.UENRegex);
    return this.matchRegex(regex,event.key);
  }
  validateCreditorNameOrCompanyName(event){
    var regex = new RegExp(this.fieldLength.CompanyNamePattern);
    return this.matchRegex(regex,event.key);
  }

  omitCountryCodeCharacters(e){
    var regex = new RegExp("^[+0-9]$");
    return this.matchRegex(regex,e.key);
  }
  omitContactNumberCharacters(e) {
    var regex = new RegExp("^[0-9]$");
    return this.matchRegex(regex,e.key);
  }
  OmitUpDownKeys(e) {
    var k;
    document.all ? k = e.keyCode : k = e.which;
    if (k === 0x26 || k === 0x28)
      {
          return false;
      }
  }

  omitMessageBodyCharacters(event) {
    var regex = new RegExp(this.fieldLength.MessageBodyRegex);
    return this.matchRegex(regex,event.key);
  }
  
  validateEmailCharacters(e) {
    var k;
    document.all ? k = e.keyCode : k = e.which;
    var regex = new RegExp("^[a-zA-Z0-9@+.\\-\\_]$");
    var key = e.key;
    if (!regex.test(key) || k == 94) {
      e.preventDefault();
      return false;
    }
  }
  validateCompanyNameCharacters(event){
    var regex = new RegExp(this.fieldLength.CompanyNamePattern);
    return this.matchRegex(regex,event.key);
  }

  emailKeyValidation(event) {
    var k;
    document.all ? k = event.keyCode : k = event.which;
    var regex = new RegExp("^[a-zA-Z0-9@+.\\-\\_]$");
    var key = event.key;
    if (!regex.test(key) || k == 94) {
      event.preventDefault();
      return false;
    }
  }

  convertToThousandSeparator(value:string){
    var result="";
    if(value.includes(".")){
      result=this.convertNumber(value.split(".")[0]);
      result = result.concat(".").concat(value.split(".")[1]); 
      return result; 
    }
    else{
      return this.convertNumber(value);
    }
  }
  convertNumber(inputNumber:string){
    var result="", separatorDigits=3;
    var reverseNumber = inputNumber.split("").reverse().join('');
    if(inputNumber.length>separatorDigits){
        for(let index=0;index<reverseNumber.length;index++){ 
          if(index%separatorDigits==0 && index>=separatorDigits && reverseNumber.charAt(index)!="-"){ 
            result = result.concat(",").concat(reverseNumber[index]);
          }
          else{
            result = result.concat(reverseNumber[index]);
          }
        }
        //Concat decimals at last
        result = result.split("").reverse().join('');
      return result; 
    }
    else{
      return inputNumber;
    }
  }
}
